import './PairingEvent.scss';
import { useEffect, useState } from 'react';
import EventCheckInOut from '../EventCheckInOut/EventCheckInOut';
import PairingLayoverSegment from '../PairingEventLayoverSegment/PairingEventLayoverSegment';
import PairingRouteSegment from '../PairingEventRouteSegment/PairingEventRouteSegment';
import { getLeftMargin } from '../../StandardCalendar/StandardCalendarHelper';
import { formatNumToTime } from '../../../helpers/timeHelpers';

export default function PairingEvent({actualView, event, width}) {
    const [pairingDetails, setPairingDetails] = useState ({
        id: '0',
        startTime: '0',
        endTime: '0',
        segments: [] as any,
        hasLayover: false,
        releaseWidth: 0,
    })

    const [segmentLengthPx, setSegmentLengthPx] = useState(0);

    const getSegmentLength = (startDate, endDate) => {
        const dayLength = width;
        const diffInHours = Math.abs(startDate.getTime() - endDate.getTime())/3.6e6;
        const minutes = diffInHours * 60;
        const length = dayLength * (minutes/1440);
        return length
    }

    useEffect(() => {
        if(!event.pairingSegments) return;
        const segmentLengthTotal = event.pairingSegments.reduce((accum,segment) => accum + segment.segmentLength,0)
        setSegmentLengthPx(segmentLengthTotal*100);
        setPairingDetails({
            hasLayover: event.pairingSegments.findIndex(segment => !segment.isRoute) !== -1,
            releaseWidth: event.release ? getReleaseSegmentLength() : 0,
            id: event.activityId,
            endTime: formatNumToTime(event.checkOut.value),
            segments: event.pairingSegments,
            startTime: formatNumToTime(event.hasStartRelease && event.carryIn ? event.release[0].checkOut.value :event.checkIn.value)
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event, width])

    const getReleaseSegmentLength = () => {
        const releaseStartTime = new Date(`${event.release[0].start_date} ${formatNumToTime(event.release[0].checkIn.value)}`);
        const releaseEndTime = new Date(`${event.release[0].end_date} ${formatNumToTime(event.release[0].checkOut.value)}`);
        const releaseSegmentLength = getSegmentLength(releaseStartTime, releaseEndTime);
        return releaseSegmentLength;
    }

    const getEventContainerStyle = () => {
        const checkInValue = event.hasStartRelease ? event.release[0].checkIn.value : event.checkIn.value;
        const marginTop = event.hideEventId ? 1.5 : 0.2;
        return ({
            left: `${getLeftMargin(checkInValue)}%`,
            marginTop: `${marginTop}rem`,
            width: `${segmentLengthPx}%`
        })
    }


    return (
        <div className="standard-calendar__c-pairing-event" style={getEventContainerStyle()}>
            {!event.hideEventId && (
                <span 
                    id={`pairingId__${event.unique_id}`} 
                    className="pairing-id" 
                    style={{paddingLeft:`${pairingDetails.releaseWidth}px`}}
                >
                    {pairingDetails.id}
                </span>
            )}
            <div className="pairing__c-inner" style={{ width: `100%`}}>
                {pairingDetails.segments.map((segment, index) => {
                    return (
                        segment.isRoute 
                        ? <PairingRouteSegment 
                            actualView={actualView}
                            event={event}
                            index={index}
                            pairingDetails={pairingDetails}
                            segment={segment}
                            width={segmentLengthPx}
                        /> 
                        : <PairingLayoverSegment 
                            segment={segment} 
                            uniqueId={event.unique_id} 
                            width={segmentLengthPx}
                        />
                    )
                })}
            </div>
            {!pairingDetails.hasLayover && pairingDetails.segments.length && ( 
                <EventCheckInOut 
                    actualView={actualView} 
                    event={event} 
                    eventType={event.activityType} 
                    pairingDetails={pairingDetails} 
                    segmentLengthPx={segmentLengthPx}
                />
            )}
        </div>
    )   
}
